import { useAuthStore } from "@/store/useAuthStore";

export function useIsViewer(): boolean {
  const user = useAuthStore((s) => s.user);
  return user?.role === "viewer";
}

export function useIsOwner(): boolean {
  const user = useAuthStore((s) => s.user);
  return user?.role === "owner";
}

export function useIsManager(): boolean {
  const user = useAuthStore((s) => s.user);
  return user?.role === "manager";
}

export function useIsAdmin(): boolean {
  const user = useAuthStore((s) => s.user);
  return user?.role === "admin";
}
